import { Observable } from 'rxjs';

import { ISnListResponse, ISnListQueryParameters } from '@lib/api';
import { SnShare } from '@lib/api/entities';

export interface ISnCanShare {
  getShareList(
    endpointId: string,
    params?: ISnListQueryParameters,
  ): Observable<ISnListResponse<SnShare>>;

  createShare(endpointId: string, data: any, ...attr: any[]): Observable<SnShare | SnShare[]>;

  updateShare(endpointId: string, shareId: string, data: any): Observable<SnShare>;

  deleteShare(endpointId: string, shareId: string): Observable<any>;
}
